// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2FqNg","paymentContainer":"PaymentPage_paymentContainer__16hF_"};